var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"transition-transform duration-100 transform rounded-full hover:scale-105 active:scale-75 focus:outline-none"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }